<template>
    <div :class="'search ' + $store.getters['searchState']" >
      <div class="search__content">
        <div class="search__suggestions suggestions" v-if="results">
          <div class="suggestions__title">
            Suggestions
          </div>
          <div class="suggestions__content content" >
            <router-link v-if="suggestion.product_id && loading == 0" :to="{name: 'ProductDetail', params: {id: suggestion.product_id}}" class="suggestion" v-for="suggestion in results" :key="suggestion.product_id">
              <div class="suggestion__ref">
                {{ suggestion.product_code }}
              </div>
              <div class="suggestion__name" >
                <span v-html="$options.filters.bold(suggestion.product_label, searched)"></span>
                <br/>
                <small>{{ suggestion.family_name }}</small>
              </div>
            </router-link>
            <div class="suggestions__loader" v-if="loading == 1">
              <i></i>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "SearchResults",
  props: [
    "loading",
    "searched",
    "nav"
  ],
  data() {
    return {
    }
  },
  filters: {
    // Mise en gras de la sous-chaine cherchée dans le résultat affiché
    bold: function (res, searched) {
      if (!res) return ''
      return res.toUpperCase().replace(searched.toUpperCase(), '<strong>' + searched.toUpperCase() + '</strong>');
    }
  },
  computed: {
    // Récupération des résultats stockés côté Vue (après requête AJAX les résultats sont stockés, on les récupère ici)
    results: function() {
      let results = this.$store.getters['search/getResults'];
      return results;
    }
  },
  methods: {
    // Affiche ou cache la recherche
    toggleSearch(){
      this.$store.dispatch('toggleSearch');
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisfonce;
    border-radius: 20px;
    height: 5px;
  }

  .search{ position: fixed; height: auto; border-bottom: 1px solid $grisclair; max-height: calc(100vh - 135px); left: 0; top: -100vh; width: 75%; background-color: white; z-index: 11; transition: top 300ms ease-in-out; display: flex; flex-direction: column;
    &.active{ top: 135px; }
    &__header{ height: auto; padding: 100px 30px 30px 30px;
      input{ background-color: transparent; border: none; width: 100%; color: $color3; border: none; height: 35px; font-size: 25px; outline: none; font-family: 'ClanPro'; }
      input:-internal-autofill-selected{ display: none; background-color: transparent !important;  }
      a{ position: absolute; top: 10px; right: 30px;
        img{ width: 30px; }
      }
    }
    &__content{ background-color: white; flex: 1; padding: 20px 30px 40px;  overflow: auto;
      .suggestions{ display: flex; position: relative;
        &__title{ color: $color3; font-size: 16px; font-family: 'ClanProBold'; width: 130px;

        }
        &__content{ display: flex; flex-wrap: wrap;
          .suggestion{ display: flex; font-size: 12px; font-family: 'ClanPro'; margin-bottom: 10px; width: calc(100% / 3);
            &__ref{ margin-left: 40px; margin-right: 20px; color: $grisfonce; width: 80px; }
            &__name{ font-family: 'ClanPro';  color: $grisfonce; font-size: 12px; flex: 1;
              span{
              }
              strong{ font-family: 'ClanProBold'; font-weight: normal; }
              small{ font-family: 'ClanPro'; font-size: 10px; }
            }
            &:hover{ text-decoration: none; }
          }
        }
        &__loader { background-color: $color1; height: 50px; width: 50px; border-radius: 50%; text-align: center; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
            i { display: block; margin: 0 auto;
              &:before { content: "."; animation-name: load; animation-duration: 800ms; animation-iteration-count: infinite; width: auto; color: white; display: inline-block; font-size: 23px;
              }
            }
          }
      }
    }
    &.mobile{ top: 167px; position: absolute;
      .search__suggestions{
        .suggestions__content{
          .suggestion{ width: 100%;
            &__ref{  }
            &__name{ flex: 1; text-align: left;  }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1680px){
    .search{ width: calc(100% - 415px);  }
  }

  @media screen and (max-width: 450px){
    .search__content{
      .suggestions{ width: 100%; display: block !important;
        &__title{ margin-bottom: 20px; }
      }
      .suggestion{
        &__ref{ margin-left: 0 !important; }
      }
    }
  }
  @keyframes load {
    0% {
      content: ".";
    }
    33% {
      content: "..";
    }
    66% {
      content: "...";
    }
    100% {
      content: ".";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/SearchResults.vue